import { ServiceRequestBase } from "../ServiceRequestBase";

export class SendUsernameRequest extends ServiceRequestBase {
  public EmailAddress: string | null = null;
}
